$(document).on("turbolinks:load", function() {
  $("[data-modal]").each(function() {
    el = $(this).data("modal");
    title = $(this).data("title");
    $(this).fireModal({title: title, body: $(el), center: true});
  });
});
